// Used by Day 3, Day 21, Peak +7, Male, and Blank 
const APL_PATIENT_FIELDS = {
  uli:        'PHN',
  dob:        'Date of Birth',
  lastName:   'Legal Last Name',
  firstName:  'Legal First Name',
  phone:      'Phone',
  address:    'Address',
  city:       'CityTown',
  province:   'Prov',
  postalCode: 'Postal Code',
};

const APL_PROVIDER_FIELDS = {
  providerName:    'Authorizing Provider Name last first middle',
  providerAddress: 'Address_2',
  providerID:      'CC Provider ID',
  providerPhone:   'Provider Phone',
  providerFax:     'Provider Fax',
  clinicName:      'Clinic Name',
};

// Semen Analysis - same APL patient fields except DOB, plus its own
// (internally mislabeled) provider field names. 23017 submitter ID is a
// fillable field here, unlike the other APL forms where it is pre-printed.
const SEMEN_PATIENT_FIELDS = {
  uli:        'PHN',
  dob:        'Dob-1_af_date',
  lastName:   'Legal Last Name',
  firstName:  'Legal First Name',
  phone:      'Phone',
  address:    'Address',
  city:       'CityTown',
  province:   'Prov',
  postalCode: 'Postal Code',
};

const SEMEN_PROVIDER_FIELDS = {
  providerName:    'Authorizing Provider Name last first middle',
  providerID:      'CC Provider ID',
  submitterID:     'CC Submitter ID-1',
  providerAddress: 'Provider Address 2',
  providerPhone:   'Provider Phone',
  clinicName:      'Clinic Name',
};

// Referral Letter
const REFERRAL_PATIENT_FIELDS = {
  fullName: 'Patient Name',
  uli:      'Patient PHN',
  dob:      'Patient DOB',
  phone:    'Patient Contact',
};

const REFERRAL_PROVIDER_FIELDS = {
  providerName:       'Provider Name',
  providerID:         'Provider ID',
  providerLicense:    'Provider License',
  providerEmail:      'Provider Email',
  officeAddress:      'Office Address',
  referringClinician: 'Referring Clinician',
  date:               'Date',
};

// AcroForm checkbox names for the gender row 
export const GENDER_CHECKBOX_NAMES = {
  male:      'male',
  female:    'female',
  nonBinary: 'non-binary',
  preferNot: 'no-disclose-gender',
};

// Clinic-level constants 
export const CLINIC_CONSTANTS = {
  clinicName:    'My Fertility Labs',
  clinicAddress: '11444 17 Ave SW, Edmonton, AB, T6W 2S5',
  phone:         ' ',
  fax:           '825-902-8022',
  submitterID:   '23017',
};

// Per-template config: 
export const TEMPLATE_CONFIG = {
  Day3: {
    filename: 'day 3 requisition.pdf',
    patientFields: APL_PATIENT_FIELDS,
    providerFields: APL_PROVIDER_FIELDS,
    hasGender: true,
  },
  Day21: {
    filename: 'day21.pdf',
    patientFields: APL_PATIENT_FIELDS,
    providerFields: APL_PROVIDER_FIELDS,
    hasGender: true,
  },
  PeakPlus7Fasting: {
    filename: 'peak-plus7-fasting.pdf',
    patientFields: APL_PATIENT_FIELDS,
    providerFields: APL_PROVIDER_FIELDS,
    hasGender: true,
  },
  Male: {
    filename: 'male requisition.pdf',
    patientFields: APL_PATIENT_FIELDS,
    providerFields: APL_PROVIDER_FIELDS,
    hasGender: true,
  },
  Semen: {
    filename: 'Semen Requisition.pdf',
    patientFields: SEMEN_PATIENT_FIELDS,
    providerFields: SEMEN_PROVIDER_FIELDS,
    hasGender: true,
  },
  Blank: {
    filename: 'Blank Requisition.pdf',
    patientFields: APL_PATIENT_FIELDS,
    providerFields: APL_PROVIDER_FIELDS,
    hasGender: true,
  },
  Referral: {
    filename: 'Referral Letter – Fertility Clinic.pdf',
    patientFields: REFERRAL_PATIENT_FIELDS,
    providerFields: REFERRAL_PROVIDER_FIELDS,
    hasGender: false,
  },
};
